import app from '$$app';
import ganttViewModel from '$$ganttViewModel';
import Store from '$$globalStore';

function onCustomFieldFromProjectUnassigned(event) {
  const ganttIDs = ganttViewModel.getGanttIDs();
  const columnsFromProjects = event.data.unassignedCustomFields;
  const projectIds = [];

  columnsFromProjects.forEach(el => {
    Store.commit('columns/removeColumnFromProjects', { columnId: el.customFieldId, projectIds: el.projectIds });
    projectIds.push(...el.projectIds);
  });

  if (ganttIDs && ganttIDs.length) {
    app.trigger('userCustomColumnsModel:change', ganttIDs[0]);
  }

  app.trigger('userCustomColumnsModel:change');

  app.trigger('onAfterCollaboration', {
    event: event.event,
    unassignedCustomFields: columnsFromProjects,
    projects: [...new Set(projectIds)],
  });
}

export default onCustomFieldFromProjectUnassigned;
